import { ChevronIcon } from "@images/svgIcons/chevronIcon"
import { CoachNoteIcon } from "@images/svgIcons/coachNoteIcon"
import { word } from "@modules/core/utils/i18n"
import { AthleteNote } from "@modules/sessionBlock/notes/noteTypes"
import { HUButton } from "@modules/ui/components/huButton"
import { HUText } from "@modules/ui/components/huText"
import { HURichTextView } from "@modules/ui/components/richText/huRichTextView"
import { formatTextToRichText } from "@modules/ui/components/richText/richTextUtils"
import { ThemeMode } from "@modules/ui/styles/theme"
import { useState } from "react"
import { useTheme } from "styled-components"

type Props = {
  note: AthleteNote
} & React.HTMLAttributes<HTMLDivElement>

export const NoteForAthletesDetails: React.FC<Props> = ({ note, ...props }) => {
  const [isContentDisplayed, setIsContentDisplayed] = useState(true)
  const theme = useTheme()
  return (
    <div
      className={
        "flex flex-column p-3 pt-2 pl-1 rounded-big-radius border-1 border-neutralColor-200 border-dashed " +
        (theme.mode === ThemeMode.OWNER ? "bg-neutralColor-50" : "")
      }
      {...props}
    >
      {/* Note card header */}
      <div className="flex flex-row align-items-center justify-content-between">
        <div className="flex flex-row align-items-center justify-content-start">
          <CoachNoteIcon color={theme.neutralColor700} />
          <div className="flex flex-column">
            <HUText color={theme.neutralColor700} fontStyle="TS">
              {word("sessionForm.blocks.note_for_athletes")}
            </HUText>
          </div>
        </div>

        <HUButton
          type="Rounded"
          colorType="Quaternary"
          size="XS"
          icon={{
            icon: () => (
              <ChevronIcon color={theme.neutralColor700} className={isContentDisplayed ? "rotate-180" : "rotate-0"} />
            ),
          }}
          className="cursor-pointer border-1 border-transparent"
          onClick={() => setIsContentDisplayed(!isContentDisplayed)}
        />
      </div>

      {/* Note card content */}
      {isContentDisplayed && (
        <div style={{ paddingLeft: 50 }}>
          <HURichTextView value={formatTextToRichText(note.note)} paragrapheFontStyle="BS" />
        </div>
      )}
    </div>
  )
}
